import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { LessThanTenDivider } from '../../components/specials/home/LessThanTenDivider';

Builder.registerComponent(LessThanTenDivider, {
    name: BUILDER_DIVIDER_NAMES.LipsOrUnderArmsDivider,
});
